import { render, staticRenderFns } from "./Nabavke.vue?vue&type=template&id=6ba504fe&"
import script from "./Nabavke.vue?vue&type=script&lang=js&"
export * from "./Nabavke.vue?vue&type=script&lang=js&"
import style0 from "./Nabavke.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports